module.exports = __webpack_public_path__ + "f07373b3e5d689f0e6eb548f92e1376d.png";